import * as React from 'react';
import { clsx as cn } from 'clsx';
import { UiKitThemeContext } from '../internal/context';
import { jsx as _jsx } from "react/jsx-runtime";
export var Theme = function Theme(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  var value = React.useMemo(function () {
    return {
      theme: theme
    };
  }, [theme]);
  if (!theme) {
    return /*#__PURE__*/_jsx("div", {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(UiKitThemeContext.Provider, {
    value: value,
    children: /*#__PURE__*/_jsx("div", {
      className: cn({
        'design-theme--dark': theme === 'dark',
        'design-theme--colored': theme === 'colored',
        'design-theme--onOverlay': theme === 'onOverlay'
      }),
      children: children
    })
  });
};